export interface IMergeUrls {
	[IMergeUrlsKeys.landingPage]: string;
	[IMergeUrlsKeys.smartWallet]: string;
	[IMergeUrlsKeys.whitePaper]: string;
	[IMergeUrlsKeys.visionLoyaltyProgramme]: string;
	[IMergeUrlsKeys.governance]: string;
	[IMergeUrlsKeys.visionProtocol]: string;
	[IMergeUrlsKeys.visionToken]: string;
}

export enum IMergeUrlsKeys {
	landingPage = "landingPage",
	smartWallet = "smartWallet",
	whitePaper = "whitePaper",
	visionLoyaltyProgramme = "visionLoyaltyProgramme",
	governance = "governance",
	visionProtocol = "visionProtocol",
	visionToken = "visionToken"
}
